import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import InputAdornment from '@mui/material/InputAdornment';
// import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import Button from '@mui/material/Button';

import Swal from 'sweetalert2'
import './Login.css'
import { Link, useNavigate } from 'react-router-dom';
import { fetchOtp, matchOtpService } from '../components/ApiService'
import { CircularProgress } from '@mui/material';

const Login = () => {
    const [contact, setContact] = useState('')
    // const [otp, setOtp] = useState("")
    const [showOtp, setshowOtp] = useState(false)
    const [message, setMessage] = useState('');
    const [showRequestOtpBtn, setshowRequestOtpBtn] = useState(true)
    const [openProgressLoader, setopenProgressLoader] = useState(false)
    const [timeLeft, setTimeLeft] = useState(0);
    const [isRunning, setIsRunning] = React.useState(false)
    const [matchOtp, setMatchOtp] = useState('')
    const [storeUserToken, setstoreUserToken] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((time) => time - 1)
            }, 1000)
        } else if (timeLeft === 0) {
            setIsRunning(false)
        }
        return () => clearInterval(timer)
    }, [isRunning, timeLeft])

    // TIMER 
    const startTimer = () => {
        if (!isRunning) {
            setTimeLeft(30);
            setIsRunning(true)
        }
    }

    const getContact = (event) => {
        const value = event.target.value

        if (/^\d*$/.test(value)) {
            setContact(value)
            const regex = /^\d{10}$/;
            if (value.length === 0 || regex.test(value)) {
                setMessage(value.length === 10 ? 'Mobile number is valid.' : '');
            } else {
                setMessage('Mobile number must be exactly 10 digits.');
            }
        } else {
            setMessage('Only digits are allowed.');
        }
    }

    const getOtp = () => {
        setopenProgressLoader(true)
        const pattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
        console.log(contact, "contact no")
        // CALL TIMER FUNCTION
        startTimer()
        if (contact == "" || contact.length !== 10) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Contact number must be of 10 digits"
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        }else if(!contact.match(pattern)){
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Enter Valid Contact number"
            });
            setopenProgressLoader(false)
            setContact("")
            setMessage('')
        } else {
            setshowRequestOtpBtn(false)
            setshowOtp(true)
            setMessage('')

            const obj = {
                "phoneCountryCode": "+91",
                "phoneNumber": contact
            }

            fetchOtp(obj).then((res) => {
                console.log(res, "OTP")
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "success",
                    title: res.data.message
                });
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
            }).catch((error) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: error?.response?.data.message ? error?.response?.data.message : "Something Went Wrong!" 
                });
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
            }).finally(() => {
                setopenProgressLoader(false)
            })
        }
    }

    const submitLogin = () => {
        setopenProgressLoader(true)
        const obj = {
            "phoneCountryCode": "+91",
            "phoneNumber": contact,
            "phoneOtp": matchOtp
        }

        if ((contact == "" || contact.length != 10 ) && matchOtp == '') {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "All fields are mandatory!"
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        } else {
            matchOtpService(obj).then((res) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "success",
                    title: res.data.message
                });
                console.log(res.data, "login res")
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);

                var storeUserToken = res.data.token;
                var storeUserInfo = res.data.user
                setstoreUserToken(res.data.token)

                // console.log(storeUserToken, "storeUserToken")
                // console.log(storeUserInfo, "storeUserInfo")
                let itemsObj = {
                    "token" : storeUserToken,
                    "userDetails" : storeUserInfo
                }
                localStorage.setItem("user", JSON.stringify(itemsObj))
                navigate("/")
            }).catch((err) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: err?.response?.data.message ? err?.response?.data.message : "error" 
                });
                // console.log(err.response.data, "error login")
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
            })
        }
    }


    return (
        <>
            {/* LOADER */}
            {openProgressLoader ?
                <div className='progressCont'>
                    <CircularProgress size='5rem' color='secondary' className='loadCnt' />
                </div>
                : ""
            }

            <section className='registrationCont'>
                <div className='registerBox'>
                    <div className='registerLeft'>
                        <img src="images/logo.png" className='img-fluid' alt='car-genie' />
                    </div>
                    <form className='registerForm'>
                        <h4> Welcome, Log In to continue! </h4>
                        <Box autoComplete="off" className="registerCont">
                            {/* CONTACT NUMBER */}
                            <TextField
                                label="Enter Contact Number"
                                margin="normal"
                                id="outlined-start-adornment2"
                                type='tel'
                                color="secondary"
                                maxLength="10"
                                value={contact}
                                required
                                // pattern="\d{3}[\-]\d{3}[\-]\d{4}"
                                // sx={{ m: 1, width: '25ch' }}
                                onChange={getContact}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                                    },
                                }}
                            />
                            {message && (
                                <p style={{ color: message === 'Mobile number is valid.' ? 'green' : 'red' }}>
                                    {message}
                                </p>
                            )}

                            {showRequestOtpBtn ?
                                <Button variant="contained" style={{ marginTop: '10px' }} onClick={getOtp}>Request OTP</Button>
                                : ""}

                            {showOtp ?
                                <>
                                    <TextField
                                        label="OTP"
                                        margin="normal"
                                        id="outlined-start-adornment3"
                                        color="secondary"
                                        onChange={(e) => setMatchOtp(e.target.value)}
                                        required
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment>
                                                    <LockOpenTwoToneIcon color="action" />
                                                </InputAdornment>,
                                            },
                                        }}
                                    />

                                    <div className='otpTimerCont'>
                                        {isRunning ?
                                            <p style={{ marginBottom: '0', marginRight: '20px' }}>Resend OTP will enable in {timeLeft} secs! </p>
                                            : ""}
                                        <Button variant="contained" style={{ marginTop: '10px' }} onClick={getOtp} disabled={isRunning}>Resend OTP</Button>
                                    </div>
                                </>
                                : ""}

                            {showOtp ?
                                <Button variant="contained" style={{ marginTop: '10px' }} onClick={submitLogin}>Proceed</Button>
                                :
                                ""
                            }

                            <p style={{ marginTop: '10px' }}>Don't have an account?  
                                <Link to="/register"> Sign Up</Link>
                            </p>
                        </Box>
                    </form>
                </div>
            </section>
        </>
    )
}

export default Login